import { INIT_DATA } from 'constants/default';
import axiosClient from './axiosClient';

const staffRequestApi = {
  /**
   *
   * @param {*} data
   * @returns {Promise<{success: boolean}>}
   */
  create: (data) => {
    const url = `/staff-request`;
    return axiosClient.post(url, data);
  },

  staffRequestByPost: (data, { params, headers }) => {
    const url = `/staff-request/get-staff-request`;
    return axiosClient.post(url, data, { params, headers });
  },

  createUser: (data) => {
    const url = `/staff-request/create-user`;
    return axiosClient.post(url, data);
  },

  /**
   * @returns {Promise<typeof INIT_DATA & {data: StaffRequestProps[]}>}
   */
  get: () => {
    const url = `/staff-request`;
    return axiosClient.get(url);
  },

  getApproval: (id, data) => {
    const url = `/staff-request/approval/${id}`;
    return axiosClient.put(url, data);
  },
  /**
   * @param {string} id
   * @param {Partial<StaffRequestProps>} data
   * @returns {Promise<StaffRequestProps>}>}
   */
  update: (id, data) => {
    const url = `/staff-request/${id}`;
    return axiosClient.put(url, data);
  },

  getDashboardCount: (params) => {
    const url = `/staff-request/get-dashboard-count`;
    return axiosClient.get(url, { params });
  },
  getTopLearningpath: (params) => {
    const url = `/staff-request/get-top-learning-paths`;
    return axiosClient.get(url, { params });
  },
  getTopCentreData: (params) => {
    const url = `/staff-request/get-top-centers`;
    return axiosClient.get(url, { params });
  },
  /**
   * @param {string} id
   * @returns {Promise<StaffRequestProps>}>}
   */
  getById: (id) => {
    const url = `/staff-request/${id}`;
    return axiosClient.get(url);
  },

  /**
   * @param {string} id
   * @returns {Promise<StaffRequestHistory[]>}>}
   */
  getStaffJourneyById: (id) => {
    const url = `/staff-request/get-staff-request-history/${id}`;
    return axiosClient.get(url);
  },
  getEmailTemplateById: (id) => {
    const url = `/staff-request/get-staff-request-history-by-id/${id}`;
    return axiosClient.get(url);
  },
  getAcceptUser: (data, params) => {
    const url = `/staff-request/get-created-staff?id=${params?.id}`;
    return axiosClient.post(url, data);
  },
};

export default staffRequestApi;

/**
 * Staff Schema
 * @typedef {object} StaffRequestProps
 * @property {string} staffFirstName - First name of the staff (max length: USER_FIRST_NAME_MAX_LENGTH)
 * @property {string} staffLastName - Last name of the staff (max length: USER_LAST_NAME_MAX_LENGTH)
 * @property {import('./userApi').UserProps} email - Email of the staff
 * @property {import('./userApi').UserProps} transferEmail - Transfer email of the staff
 * @property {string} PreviousEmailStaff - Previous email of the staff
 * @property {Date} lastWorked - Last working date for the staff
 * @property {CourseCentre} courseCentre - Reference to the associated CourseCentre
 * @property {CourseCentre} transferCourseCentre - Reference to the associated CourseCentre
 * @property {string} requestType - Type of request (ON_BOARDING, TRANSFER_STAFF, OFF_BOARDING)
 * @property {string} previousEntity - Previous entity associated with the staff
 * @property {string} staffPrevious - Staff previous associated with the staff
 * @property {import('./staffTypeApi').StaffTypeSchema} designation - Reference to the StaffType designation
 * @property {string} language - Language preference (ENGLISH, CHINESE)
 * @property {string} residenceAddress -
 * @property {string} interviewSchedule - Whether interview is scheduled (YES, NO)
 * @property {Date} startDate - Start date for the staff
 * @property {Date} lastDate - Last date for the staff
 * @property {Date} createdAt - Created At for the staff
 * @property {Date} updatedAt - Last date for the staff
 * @property {string} staffContactNumber - Contact number of the staff
 * @property {string} passportNo - Passpor number of the staff
 * @property {string} comments - Additional comments
 * @property {string} notificationLetter - Reference to the notification letter file
 * @property {string} childAidCertification - Reference to the child aid certification file
 * @property {string} sponsorShipAgreement - Reference to the sponsorship agreement file
 * @property {string} employmentAgreement - Reference to the employment agreement file
 * @property {string} nricPassport - Reference to the NRIC/Passport file
 * @property {string} status - Status of the request (APPROVED, REJECTED, PENDING, NOTIFIED, default: PENDING)
 * @property {string} reason - Status of the request (APPROVED, REJECTED, PENDING, NOTIFIED, default: PENDING)
 * @property {string} _id
 * @property {import('./userApi').UserProps} creator
 */

/**
 * @typedef {Object} StaffRequestHistory
 * @property {string} staffRequest - Reference to the related StaffRequest document.
 * @property {keyof typeof STAFF_REQUEST_TYPES} type - The type of request history, must be one of STAFF_REQUEST_TYPES.
 * @property {keyof typeof STAFF_REQUEST_STATUS} status - The status of the request history, must be one of STAFF_REQUEST_STATUS.
 * @property {boolean} [isLast=true] - Indicates if this is the latest request history entry.
 * @property {string[]} linkedList - List of related StaffRequestHistory entries.
 * @property {string} createdBy - Reference to the User who created this entry.
 * @property {StaffRequestProps} formObject - Contains form-related details.
 * @property {Object} notification - Stores notification-related information.
 */
